<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('date')">
              <a-range-picker v-model="queryParam.endTime" format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('customer.appName')">
              <a-select v-model="queryParam.appssid">
                <a-select-option v-for="item in appList" :key="item.appssid">
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="8">
            <a-form-item :label="$t('custServiceWorkOrder.handleStatus')">
              <dict-select v-model="queryParam.status" :dict-code="DICT_CODE.repayCertWorkOrderStatus"
                :begin="[{ value: '', label: 'All', labelEn: 'All' }]" :placeholder="$t('select')">
              </dict-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <a-form-item label="CUIT">
              <a-input v-model="queryParam.ext" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('order.orderNo')">
              <a-input v-model="queryParam.orderNo" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item label="dataKey">
              <a-input v-model="queryParam.remark" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('reset')
              }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <!-- Remark modal -->
      <a-modal v-model:visible="visibleremark" :title="$t('remark')">
        <a-textarea v-model:value="remark" placeholder="Please enter" :auto-size="{ minRows: 4, maxRows: 6 }" />
        <template #footer>
          <a-button key="back" @click="handleCancelremark">{{ $t('cancel') }}</a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="handleremarkOk">{{ $t('confirm')
          }}</a-button>
        </template>
      </a-modal>
      <a-modal v-model:visible="visibleUrl">
        <div style="margin: 20px">{{ url }}</div>
        <template #footer>
          <a-button key="back" @click="handleCancelurl">{{ $t('cancel') }}</a-button>
          <a-button key="submit" type="primary" :loading="loading" @click="copy(url)">{{ $t('teleMarket.copy')
          }}</a-button>
        </template>
      </a-modal>
      <a-modal :title="$t('repaycert.confirmStatus')" :visible="handlevisible" :maskClosable="false"
        :confirmLoading="confirmLoading" :width="'100%'" :height="'100vh'" :style="{ 'top': '0px;','padding':'0px' }" :padding="'0px'" @ok="handlestatus"
        @cancel="handleCancel" :footer="null">
        <!-- <img :src="handleDetailRow.imgUrlFiles.0.url" alt=""> -->
        <div class="ccon">
          <div class="imgbbox">
            <div href="" @wheel="handleWheel">
              <img :style="imageStyle" :src="recordImgurl" alt="" />
            </div>

          </div>

          <div class="chuli" style="margin-left: 150px;">
            <!-- 7379227635252986881 -->
            <div class="chuliBox">
              <span>Processing Status:</span>
              <a-select v-model="handleDetailRow.status" style="width: 260px;">
                <a-select-option :value="0">Not Written Off</a-select-option>
                <a-select-option :value="20">Manual Check</a-select-option>
                <a-select-option :value="30">Invalid Voucher</a-select-option>
                <a-select-option :value="40">CUITUnable to Verify</a-select-option>
              </a-select>
            </div>
            <div class="chuliBox">
              <span>Repayment Amount:</span>
              <a-input v-model="handleDetailRow.repayAmount" />
            </div>
            <div class="chuliBox">
              <span>CUIT:</span>
              <a-input v-model="handleDetailRow.ext" />
            </div>
            <div class="chuliBox">
              <a-button type="cancel" @click="handleCancel" style="margin-right: 20px;">Cancel</a-button>
              <a-button type="primary" @click="handlestatus" :loading="confirmLoading">Confirm</a-button>
            </div>
            <div class="chuliBox" style="margin-top: 230px;">
              <a-icon type="plus-circle" @click.prevent="scaleUp" style="font-size: 20px;margin-right: 30px;" />
              <a-icon type="minus-circle" @click.prevent="scaleDown" style="font-size: 20px;" />
            </div>
          </div>
        </div>

      </a-modal>
      <a-table key="id" ref="table" size="middle" rowKey="taskId" :columns="columns" :dataSource="dataSource"
        :pagination="false" :loading="loading" bordered>
        <span slot="appIdName" slot-scope="text, record">
          <p>{{ record.appSsid }} - {{ record.appName }}</p>
        </span>
        <div slot="imgFileUrls" slot-scope="text, record">
          <div v-viewer="viewOptions">
            <div style="cursor: pointer" v-for="(item, index) in record.imgUrlFiles" href="">
              <img style="margin: 10px 0px" class="image" :src="item.url" alt="" />
            </div>
          </div>
        </div>
        <span slot="action" slot-scope="text, record">
          <a-button type="primary" size="small" @click="handleDetail(record)"
            style="margin-right: 5px; margin-bottom:10px">
            {{ record.status == 0 ? $t('handle') : $t('repaycert.modifyStatus') }}</a-button>
          <a-button type="primary" size="small" @click="editRemark(record)" style="margin-left: 5px">
            {{ $t('remark') }}</a-button>
          <a-button type="primary" size="small" @click="handleOrderDetail(record)" style="margin-left: 5px">
            {{ $t('order.repaymentPlan') }}</a-button>
        </span>
      </a-table>
      <div style="margin: 10px 0px; display: flex; justify-content: flex-end">
        <v-pagination v-if="total" :page-num="form.pageNum" :page-size="form.pageSize" :total="total"
          @change="handleTableChange" />
      </div>
    </div>

    <a-modal :loading="loading" :footer="null" :visible="pictureVisible" :destroyOnClose="true" :maskClosable="false"
      :confirmLoading="confirmLoading" :width="500" @cancel="handleCancel">
      <p>
        <span>Disk No.:</span> <span>{{ this.currImgInfo.appSsid }}</span>
      </p>
      <p>
        <span>Order No.:</span> <span> {{ this.currImgInfo.orderNo }} </span>
      </p>
      <div ref="canvasRef" style="display: flex; justify-content: space-around">
        <div class="active">
          <img style="margin: 10px; width: 200px" :src="this.currImgInfo.imgUrl" />
          <!-- <a @click="btndownload()">Download</a> -->
          <a-button type="primary" @click="btndownload()" :loading="loading"> Download </a-button>
        </div>
      </div>
    </a-modal>

    <TestInstallOrderListModal ref="modalFormF"></TestInstallOrderListModal>
  </div>
</template>

<script>
import exportFile from '@/webpublicapi/exportFile'
import { filterObj } from '@/utils/util'
import { getApplist } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import vModal from '../modules/Modal'
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import {
  repayCertWorkOrderList,
  createPayOrder,
  updateRepayCertWorkOrder2
} from '@/webpublicapi/CollectionAccountInfo'
import { createRepayUrlFunc, createInstallmentRepayUrl } from '@/webpublicapi/order'
import TestInstallOrderListModal from './modules/TestInstallOrderListModal'
import imageMixin from '../../../mixins/image-mixin'
import { updateStatusSupervielle } from '@/webpublicapi/importSalaryCommon'
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.',
}

export default {
  name: 'CollectionPayCertificate',
  components: {
    Dict,
    DictSelect,
    vModal,
    TestInstallOrderListModal,
  },
  mixins: [imageMixin],
  data() {
    return {
      status: "",
      zdAmt: '',
      zdAmountUrl: '',
      loadingAmt: false,
      visibleAmount: false,
      StatusItem: {
        status: '',
        id: '',
      },
      scale: 1,
      minScale: 1,
      maxScale: 5,
      record1: {},
      visibleUrl: false,
      visibleremark: false,
      I18N_KEY,
      Arrlist: [],
      toggleSearchStatus: false,
      confirmLoading: false,
      visible: false,
      handlevisible: false,
      pictureVisible: false,
      handleDetailRow: {},
      orderIds: undefined,
      // StatusItem: {
      //   status: '',
      //   id: '',
      // },
      visibleRepayUrlCard: false,
      currImgInfo: {},
      custInfoId: undefined,
      batchLoading: false,
      selectedRowKeys: [],
      selectedList: [],
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      appList: [],
      total: 0,
      dataSource: [],
      // Query conditions
      queryParam: {
        mobileNo: '',
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 },
      },
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      selectUser: '',
      ExamineUser: [],
      taskId: '',
      token: '',
      remark: '',
      url: '',
      recordImgurl: "",
    }
  },
  computed: {
    ...mapGetters('platformCollection', ['listUserWithNum']),
    batchList() {
      return this.listUserWithNum || []
    },
    imageStyle() {
      return {
        height: '90vh',
        transform: `scale(${this.scale})`,
        transition: 'transform 0.1s ease-in-out',
      };
    },
    columns() {
      return [
        {
          title: this.$t('repaycert.workorder'),
          align: 'left',
          dataIndex: 'id',
        },
        {
          title: this.$t('custServiceWorkOrder.createdTime'),
          align: 'left',
          dataIndex: 'createdTimeStr',
          // scopedSlots: { customRender: 'createdTime' },
        },
        {
          title: this.$t('order.orderNo'),
          align: 'left',
          dataIndex: 'orderNo',
        },
        {
          title: this.$t('phoneNo'),
          align: 'left',
          dataIndex: 'mobileNo',
        },
        {
          title: this.$t('customer.orderImages'),
          align: 'center',
          dataIndex: 'imgFileUrls',
          scopedSlots: { customRender: 'imgFileUrls' },
        },
        {
          title: this.$t('custServiceWorkOrder.updateTime'),
          align: 'left',
          dataIndex: 'updateTimeStr',
          // scopedSlots: { customRender: 'updateTime' },
        },
        {
          title: this.$t('custServiceWorkOrder.handleStatus'),
          dataIndex: 'status',
          align: 'center',
          customRender: function (text) {
            if (text === 0 ) {
              return "Not Verified"
            } else if (text === 10) {
              return "Auto Verified"
            } else if (text === 20) {
              return "ManualVerifyTo"
            } else if (text === 30) {
              return "Invalid Certificate"
            } else if (text === 40) {
              return "CUIT Number Cannot Verify Real"
            } else if (text === 1){
              return "Dedup Review Certificate"
            } else {
              return text;
            }
          }
        },
        {
          title: this.$t('remark'),
          dataIndex: 'remark',
          align: 'center',
          //  width: 260,
          // scopedSlots: { customRender: 'collectorMobile' },
        },
        {
          title: 'Repayment Amount',
          dataIndex: 'repayAmount',
          align: 'center',
        },
        {
          title: 'RepaymentType',
          dataIndex: 'payType',
          align: 'center',
          customRender: function (text) {
            if (text === '00' || text === '03') {
              return "FullRepayment"
            } else if (text === '01' || text === '0304') {
              return "ExtensionRepayment"
            } else {
              return text;
            }
          }
        },
        {
          title: 'CUIT',
          dataIndex: 'ext',
          align: 'center',
        },

        {
          title: this.$t('custServiceWorkOrder.operate'),
          dataIndex: 'action',
          width: 250,
          align: 'left',
          scopedSlots: { customRender: 'action' },
        },
      ]
    },
  },
  created() {
    this.loadData(this.form)
    getApplist().then((res) => {
      this.appList = res.data || []
    })
  },
  methods: {
    ...mapActions('platformCollection', ['getListUserWithNum', 'batchChangeUser']),
    handleCancelAmount() {
      this.visibleAmount = false
      this.zdAmountUrl = ''
      this.zdAmt = ''

    },
    handleWheel(event) {
      event.preventDefault();
      const delta = event.wheelDelta ? event.wheelDelta : -event.deltaY;
      if (delta > 0) {
        this.scaleUp();
      } else {
        this.scaleDown();
      }
    },
    scaleUp() {
      if (this.scale < this.maxScale) {
        this.scale += 0.3; // Set zoom-in ratio per requirement
      }
    },
    scaleDown() {
      if (this.scale > this.minScale) {
        this.scale -= 0.3; // Set zoom-out ratio per requirement
      }
    },
    zdAmount(record) {
      this.record1 = record

      this.visibleAmount = true
    },
    submitAmount() {
      if (!this.zdAmt) {
        this.$message.error('Please enterAmount')
        return
      }
      this.loadingAmt = true
      let data = {
        id: this.record1.id,
        amount: this.zdAmt,
      }
      createPayOrder(data).then((res) => {
        this.loadingAmt = false
        if (res.code == 1000) {
          this.zdAmountUrl = res.data.url
        } else {
          this.$message.error(res)
        }
      })
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    editRemark(record) {
      this.record1 = record
      this.visibleremark = true
      this.remark = record.remark
    },
    handleCancelurl() {
      this.visibleUrl = false
    },
    handleCancelremark() {
      this.visibleremark = false
      this.remark = ''
    },
    //Save remark
    handleremarkOk() {
      let data = {
        remark: this.remark,
        id: this.record1.id,
        status: this.record1.status,
      }
      updateRepayCertWorkOrder2(data)
        .then((res) => {
          console.log(res)
          if (res.code == '1000') {
            this.$message.success('RemarkSuccess')
            this.visibleremark = false
            this.remark = ''
            this.loadData()
          } else {
            this.$message.error(res)
          }
          // if(res.data.code)
          this.loadData()
        })
        .then((err) => {
          console.log(err)
        })
    },
    // Query
    searchQuery() {
      this.loadData()
    },
    async loadData(data) {
      this.selectedList = []
      this.selectedRowKeys = []
      var params = this.getQueryParams() // Query conditions
      this.loading = true
      await repayCertWorkOrderList(params)
        .then((res) => {
          this.total = res.data.total
          this.dataSource = res.data.rows
        })
        .catch((err) => {
          console.log(err)
          this.dataSource = []
          this.total = ''
        })
      this.loading = false
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformTime2(time) {
      return moment(time).format('YYYY-MM-DD HH:mm:ss')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    handlestatus() {
      this.confirmLoading = true

      this.Getupdate(this.handleDetailRow)
    },
    async Getupdate(data) {
      await updateRepayCertWorkOrder2(data)
        .then((res) => {
          if (res.code == '1000') {
            //  this.$message.success('Update success')
            this.visible = true
            this.handlevisible = false
            this.status = ""
            this.loadData()
            this.$message.success(res.msg)

          } else {
            this.$message.error(res.msg)
          }
          this.confirmLoading = false
          this.handlevisible = false
        })
        .then((err) => {
          console.log(err)
        })
      this.visible = false
    },
    submitBatch() {
      const taskIds = this.selectedList.map((t) => t.taskId)
      const userTask = this.batchList.map((t) => ({ userId: t.userId, taskNum: t.taskNum ? +t.taskNum : 0 }))
      const totalNum = userTask.map((t) => t.taskNum).reduce((total, num) => (total += num), 0)
      console.log(userTask, totalNum)
      if (!userTask.length) {
        return this.closeBatchDialog()
      }
      if (isNaN(totalNum)) {
        return this.$message.error(this.$t('please_enter_a_positive_integer'))
      }
      if (totalNum > this.selectedList.length) {
        return this.$message.error(
          this.$t('platformCollection.cannot_be_greater_than_the_total_quantity_of_the_checked_order')
        )
      }
      this.closeBatchDialog()

      this.batchChangeUser({ taskIds, userTask })
        .then((res) => {
          console.log(res)
          this.loadData()
          this.$message.success(this.$t('success'))
        })
        .finally((res) => { })
    },
    getQueryParams() {
      const { endTime } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: endTime && endTime.length ? this.transformTime(endTime[0]) : undefined,
        endDate: endTime && endTime.length ? this.transformTime(endTime[1]) : undefined,
        collectType: 2, //Installment
        remark: this.form.remark, //Remark
        token: this.token,
      }
      delete data.endTime
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    // Pagination
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      let data = { ...this.form, ...this.queryParam }
      this.loadData()
    },
    // Reset dictionary type search box content
    searchReset() {
      var that = this
      that.queryParam.orderNo = ''
      that.queryParam.appName = ''
      that.queryParam.mobileNo = ''
      this.queryParam.settleStatus = ''
      this.queryParam.status = ''
      this.queryParam.appssid = ''
      that.queryParam.endTime = undefined
      this.form.remark = ''
      this.token = ''
      that.loadData(this.form.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    // ProcessBtn
    handleDetail(row) {
      this.status = row.status
      let a = '0'
      this.recordImgurl = row.imgUrlFiles[a].url
      // console.log(11111111112222222,this.recordImgurl)
      this.handlevisible = true
      this.handleDetailRow = JSON.parse(JSON.stringify(row))
      this.handleDetailRow.status = 20
      this.orderIds = row.orderIds
      this.custInfoId = row.custInfoId
      this.taskId = row.taskId
      // this.StatusItem.status = row.status
      // this.StatusItem.status = this.StatusItem.status == 1 ? 0 : 1 7377101294030291969
      this.StatusItem.id = row.id
      this.changeModal(true)
    },
    handleRepayUrl(val) {
      createInstallmentRepayUrl({ orderId: val.orderId })
        .then((res) => {
          let input = document.createElement('input')
          this.url = res.data.url
          this.visibleUrl = true
        })
        .catch((err) => {
          console.log(err)
        })
    },
    handleCancel(e) {
      this.status = ""
      this.handlevisible = false
      this.visible = false
      this.pictureVisible = false
    },
    // Processing status dropdown
    Btnstatus(val) {
      this.queryParam.status = val
    },
    Btnsquare(val) {
      this.queryParam.settleStatus = val
    },
    // ---
    btndownload() {
      this.loading = true
      let imgFilePath = this.currImgInfo.filePath
      console.log(222, imgFilePath)
      let splitArr = imgFilePath.split('/')
      const fileName = splitArr[splitArr.length - 1]
      console.log('fileName:::', fileName)
      const file = {
        fileUrl: '/api/web/webpublic/repayCertWorkOrder/getRepayCertImage?filePath=' + imgFilePath,
        fileName: fileName,
      }
      exportFile(file)
        .catch((e) => {
          this.$message.error(e.message)
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleCurrImgData(record, imgUrlInfo) {
      this.pictureVisible = true
      this.currImgInfo.filePath = imgUrlInfo.filePath
      this.currImgInfo.imgUrl = imgUrlInfo.url
      this.currImgInfo.appSsid = record.appSsid
      this.currImgInfo.orderNo = record.orderNo
      console.log(this.currImgInfo)
    },
    handleOrderDetail(record) {
      this.$refs.modalFormF.edit(record)
      this.$refs.modalFormF.title = 'repay plan'
    },
    copy(e) {
      //Copy method
      let input = document.createElement('input')
      input.value = e
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('CopySuccess')
      this.visibleUrl = false
    },
    searchBatch() {
      this.batchLoading = true
      this.getListUserWithNum({ userName: this.queryParam.inName, groupIdIn: this.queryParam.groupIdIn }).finally(
        (res) => {
          this.batchLoading = false
        }
      )
    },
    handleStatusChange(records) {
      this.loading = true
      updateRepayCertWorkOrder2(records).then(res => {
        if (res.code === 1000) {
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';

.description {
  line-height: 1.4;

  &.d_text {
    text-indent: 1em;
  }

  &.d_high_light {
    color: #fd9a38;
  }
}

.active {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.image {
  width: 100px;
  height: 100px;
}

.ccon {
  display: flex;
  justify-content: center;
}

.chuli {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 30px;
}

.chuliBox {
  width: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 40px;
  margin-bottom: 14px;
}

.chuliBox input {
  width: 260px;
}

.chuliBox span {
  display: inline-block;
  width: 100px;
  text-align: right;
  margin-right: 10px;
}

/deep/ .ant-modal {
  max-width: 100% !important;
  top: 0 !important;

  padding-bottom: 0 !important;
  margin: 0 !important;
}
/deep/ .ant-modal-content{
  width: 100vw !important;
  height: 100vh !important;
}
.image-container {
  --antd-wave-shadow-color: transparent !important;
}
/deep/ .ant-modal-body{
  padding: 0px;
}
img {
  --antd-wave-shadow-color: transparent !important;
}
.imgbbox{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
</style>
